import { observer } from 'mobx-react-lite';

import { useCommandKeyboardNavigation } from './hooks/useCommandKeyboardNavigation';

export const Events = observer(() => {
  useCommandKeyboardNavigation();
  return null;
});
